import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileBar from "./MobileBar";
import CookieBanner from "./CookieBanner";
import RouteSeo from "./RouteSeo";
import { DirectBookingBanner } from "./DirectBookingBanner";

export default function Layout() {
  const loc = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);

  return (
    <div className="App min-h-screen flex flex-col bg-cream">
      <RouteSeo />
      <DirectBookingBanner />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <MobileBar />
      <CookieBanner />
    </div>
  );
}
